import { JSX } from "react";

export default function Description(): JSX.Element {
    return (
        <section className="py-5" id="about">
            <div className="container text-center">
                <h2 className="mb-4">O nas</h2>
                <p className="lead">
                    Oferujemy kompleksową obsługę pojazdów osobowych – od drobnych napraw po zaawansowaną diagnostykę i
                    serwis.
                    Stawiamy na rzetelność, doświadczenie i indywidualne podejście do każdego klienta.
                    Gwarantujemy szybką realizację, konkurencyjne ceny i fachową pomoc.
                    Zapraszamy!
                </p>
            </div>
        </section>
    );
};